<template>
  <div>
    <div class="layout__subtitle">Виды диаграмм</div>

    <div class="uikit-charts">
      <div class="uikit-charts-item uikit-charts-item-pie-simple">
        <highcharts class="uikit-charts-item-chart" :options="pieChart" />
      </div>
      <div class="uikit-charts-item">
        <highcharts class="uikit-charts-item-chart" :options="branchesChart.options" />
      </div>
      <div class="uikit-charts-item uikit-charts-item-pie-with-legend">
        <highcharts class="uikit-charts-item-chart" :options="positionsChart.options" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";

exportingInit(Highcharts);

export default {
  name: "uikit-form",

  components: {
    highcharts: Chart,
  },

  data() {
    return {
      branchesChart: {
        switcher: "ruble",
        options: {
          lang: {
            exitFullscreen: "Выйти из режима на весь экран",
            viewFullscreen: "Развернуть на весь экран",
            loading: "Загрузка...",
            months: [
              "Январь",
              "Февраль",
              "Март",
              "Апрель",
              "Май",
              "Июнь",
              "Июль",
              "Август",
              "Сентябрь",
              "Октябрь",
              "Ноябрь",
              "Декабрь",
            ],
            weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            shortMonths: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: "С",
            rangeSelectorTo: "По",
            rangeSelectorZoom: "Период",
            downloadPNG: "Скачать PNG",
            downloadJPEG: "Скачать JPEG",
            downloadPDF: "Скачать PDF",
            downloadSVG: "Скачать SVG",
            printChart: "Напечатать график",
          },
          navigation: {
            buttonOptions: {
              theme: {
                "stroke-width": 1,
                "stroke": "#D3D8DF",
                "r": 15,
              },
            },
          },
          credits: false,
          title: {
            text: "Гистограмма",
            align: "left",
            x: -10,
            y: 10,
            style: {
              color: "#000000",
              fontWeight: "500",
              fontSize: "15px",
              lineHeight: "120%",
              fontFamily: "Fira Sans",
            },
          },
          tooltip: {
            outside: true,
          },
          chart: {
            type: "column",
            height: 280,
          },
          xAxis: {
            categories: [],
            crosshair: true,
            style: {
              fontFamily: "Fira Sans",
              fontSize: "10px",
              lineHeight: "12px",
              color: "#8E9CBB",
            },
          },
          yAxis: {
            min: 0,
            max: 2000,
            title: {
              text: "Оборот/ФОТ, тыс. ฿",
              x: -12,
              margin: 0,
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#000000",
              },
            },
            labels: {
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#8E9CBB",
              },
            },
            tickAmount: 5,
          },
          legend: { enabled: false },
          plotOptions: {
            column: {
              stacking: "normal",
              events: {
                click: this.onClickBranchesChart,
              },
            },
          },
          series: [
            {
              name: "Оборот",
              data: [
                { name: "Филиал 1", branchId: 1, y: 271, seriesName: "Оборот" },
                { name: "Филиал 2", branchId: 2, y: 1427, seriesName: "Оборот" },
                { name: "Филиал 3", branchId: 3, y: 634, seriesName: "Оборот" },
                { name: "Филиал 4", branchId: 4, y: 1488, seriesName: "Оборот" },
                { name: "Филиал 5", branchId: 5, y: 1233, seriesName: "Оборот" },
                { name: "Филиал 6", branchId: 6, y: 1683, seriesName: "Оборот" },
                { name: "Филиал 7", branchId: 7, y: 291, seriesName: "Оборот" },
                { name: "Филиал 8", branchId: 8, y: 616, seriesName: "Оборот" },
                { name: "Филиал 9", branchId: 9, y: 641, seriesName: "Оборот" },
                { name: "Филиал 10", branchId: 10, y: 157, seriesName: "Оборот" },
                { name: "Филиал 11", branchId: 11, y: 1326, seriesName: "Оборот" },
                { name: "Филиал 12", branchId: 12, y: 1591, seriesName: "Оборот" },
              ],
              color: "#0066FF",
            },
            {
              name: "ФОТ",
              data: [
                { name: "Филиал 1", branchId: 1, y: 331, seriesName: "ФОТ" },
                { name: "Филиал 2", branchId: 2, y: 36, seriesName: "ФОТ" },
                { name: "Филиал 3", branchId: 3, y: 297, seriesName: "ФОТ" },
                { name: "Филиал 4", branchId: 4, y: 252, seriesName: "ФОТ" },
                { name: "Филиал 5", branchId: 5, y: 606, seriesName: "ФОТ" },
                { name: "Филиал 6", branchId: 6, y: 677, seriesName: "ФОТ" },
                { name: "Филиал 7", branchId: 7, y: 217, seriesName: "ФОТ" },
                { name: "Филиал 8", branchId: 8, y: 849, seriesName: "ФОТ" },
                { name: "Филиал 9", branchId: 9, y: 15, seriesName: "ФОТ" },
                { name: "Филиал 10", branchId: 10, y: 208, seriesName: "ФОТ" },
                { name: "Филиал 11", branchId: 11, y: 621, seriesName: "ФОТ" },
                { name: "Филиал 12", branchId: 12, y: 94, seriesName: "ФОТ" },
              ],
              color: "#74ACFF",
            },
          ],
          exporting: {
            buttons: {
              contextButton: {
                y: -10,
                x: 0,
                height: 30,
                width: 31,
                symbolSize: 12,
                symbolStrokeWidth: 2,
                symbolStroke: "#8E9CBB",
                symbolX: 15.5,
                symbolY: 14.5,
              },
            },
          },
        },
      },
      positionsChart: {
        options: {
          lang: {
            exitFullscreen: "Выйти из режима на весь экран",
            viewFullscreen: "Развернуть на весь экран",
            loading: "Загрузка...",
            months: [
              "Январь",
              "Февраль",
              "Март",
              "Апрель",
              "Май",
              "Июнь",
              "Июль",
              "Август",
              "Сентябрь",
              "Октябрь",
              "Ноябрь",
              "Декабрь",
            ],
            weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            shortMonths: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: "С",
            rangeSelectorTo: "По",
            rangeSelectorZoom: "Период",
            downloadPNG: "Скачать PNG",
            downloadJPEG: "Скачать JPEG",
            downloadPDF: "Скачать PDF",
            downloadSVG: "Скачать SVG",
            printChart: "Напечатать график",
          },
          navigation: {
            buttonOptions: {
              theme: {
                "stroke-width": 1,
                "stroke": "#D3D8DF",
                "r": 15,
              },
            },
          },
          credits: false,
          chart: {
            height: 280,
            margin: [30, 0, 50, 0],
            style: {
              fontFamily: "Fira Sans",
            },
          },
          title: {
            text: "Круговая диаграмма с легендой справа",
            align: "left",
            x: -10,
            y: 10,
            style: {
              color: "#000000",
              fontWeight: "500",
              fontSize: "15px",
              lineHeight: "120%",
              fontFamily: "Fira Sans",
            },
          },
          legend: {
            align: "right",
            labelFormat: "<b>{percentage:,.1f}%</b> {name}",
            layout: "vertical",
            itemMarginBottom: 12,
            itemStyle: {
              fontWeight: "normal",
              fontSize: "11px",
              lineHeight: "200%",
            },
            verticalAlign: "middle",
            y: 12,
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
              size: 160,
              showInLegend: true,
              center: [70, 100],
              events: {
                click: this.onClickPositionsChart,
              },
            },
          },
          tooltip: {
            pointFormat: "<strong>{point.y}%</strong>",
          },
          series: [
            {
              type: "pie",
              innerSize: "60%",
              data: [
                { name: "Повар-сушист", y: 48, color: "#97C1FF" },
                { name: "Повар-пиццмейкер", y: 45, color: "#97F2C7" },
                { name: "Администратор филиала", y: 7, color: "#E8EB8A" },
                { name: "Водители", y: 0, color: "#FFC0DE" },
                { name: "Официант", y: 0, color: "#D6D2FF" },
                { name: "Остальные", y: 0, color: "#DFE4EF" },
              ],
            },
          ],
          exporting: {
            buttons: {
              contextButton: {
                y: -10,
                x: 0,
                height: 30,
                width: 31,
                symbolSize: 12,
                symbolStrokeWidth: 2,
                symbolStroke: "#8E9CBB",
                symbolX: 15.5,
                symbolY: 14.5,
              },
            },
          },
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 375,
                },
                chartOptions: {
                  legend: {
                    align: "center",
                    verticalAlign: "bottom",
                    itemMarginBottom: 8,
                  },
                  plotOptions: {
                    pie: {
                      center: [null, 85],
                    },
                  },
                  chart: {
                    height: 350,
                    margin: [19, 0, 50, 0],
                  },
                },
              },
            ],
          },
        },
      },
      pieChart: {
        chart: {
          type: "pie",
          height: 420,
          options3d: {
            enabled: true,
            alpha: 45,
          },
          style: {
            fontFamily: "Fira Sans",
          },
        },
        exporting: {
          buttons: {
            contextButton: {
              enabled: false,
            },
            printButton: {
              enabled: false,
            },
          },
        },
        title: {
          text: "Простая круговая диаграмма",
          align: "left",
          x: -10,
          y: 10,
          style: {
            color: "#000000",
            fontWeight: "500",
            fontSize: "15px",
            lineHeight: "120%",
            fontFamily: "Fira Sans",
          },
        },
        plotOptions: {
          pie: {
            center: [null, 100],
            size: 230,
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
            colors: [
              "#97C1FF",
              "#6396E1",
              "#97F2C7",
              "#F7A35C",
              "#8085E9",
              "#F15C80",
              "#E4D354",
              "#2B908F",
              "#F45B5B",
              "#91E8E1",
              "#979797",
              "#5AB751",
              "#434348",
              "#DD9200",
              "#B90000",
              "#C07ED8",
            ],
          },
        },
        credits: false,
        series: [
          {
            chartName: "citizenships",
            name: "Щербинка",
            filialId: 3,
            data: [
              { label: "Россия", itemId: 224, y: 3 },
              { label: "Не указано", itemId: 0, y: 1 },
              { label: "Франция", itemId: 221, y: 5 },
              { label: "Россия", itemId: 222, y: 6 },
              { label: "Россия", itemId: 225, y: 7 },
            ],
          },
        ],
        tooltip: {
          useHTML: true,
          headerFormat: "{point.point.label}<br>",
          pointFormat: "{point.y} <b>{point.percentage:,.1f}%</b>",
        },
        legend: {
          labelFormat: "{label} <b>{y}</b> {percentage:,.1f}%",
          verticalAlign: "top",
          floating: true,
          y: 300,
          padding: 5,
          maxHeight: 200,
          maxWidth: 360,
          itemStyle: "{ \"word-wrap\": \"break-word\"; \"font-weight\": \"normal\"}",
          itemMarginBottom: 10,
        },
      },
    };
  },

  computed: {
    ...mapGetters("test", ["getTableData"]),
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.uikit-charts {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  z-index: 1;
  max-width: 100%;
  margin-left: -30px;

  &-item {
    width: 410px;
    position: relative;
    z-index: 10;
    margin: 30px 0 0 30px;

    &-pie-simple {
      max-width: 350px;
    }

    &-pie-with-legend {
      max-width: 410px;

      @media screen and (max-width: 450px) {
        width: 100%;
      }
    }

    @media screen and (max-width: 700px) {
      width: 100%;
    }
  }
}
</style>
